import React, { useEffect, useState } from "react";
import AxiosInstance from "../../utils/AxiosInstance";
import { FaChartPie, FaArrowRight } from "react-icons/fa";
import * as Yup from "yup";
import { renderError } from "../../utils/ModuleFunctions";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Toptitle from "./../TopTitle";
import CustomSpinner from "./../../utils/CustomSpinner";
import { Button } from "react-bootstrap";

const Reports = () => {
	const [isLoading, setIsLoading] = useState(false);
	// const [innerLoad, setInnerLoad] = useState(false);
	const [data, setData] = useState({});
	const [zones, setZones] = useState([]);
	const [zone_selected, setSelectedZone] = useState([]);
	const [type_selected, setTypeSelected] = useState([]);
	const [reports, setReports] = useState();
	useEffect(() => {
		setIsLoading(true);
		const fetchData = async () => {
			const res = await AxiosInstance({
				method: "get",
				url: `/api/v1/residences/statistics`,
				headers: {
					"Content-Type": "application/json",
				},
			});
			setData(res.data.data);
			setIsLoading(false);
		};
		const fetchZones = async () => {
			const res = await AxiosInstance({
				method: "get",
				url: `/api/v1/zones`,
			});
			setZones(res.data.data);
		};
		const fetchReports = async () => {
			const res = await AxiosInstance({
				method: "get",
				url: `/api/v1/reports/statistics`,
				headers: {
					"Content-Type": "application/json",
				},
			});
			setReports(res.data.data);
			setIsLoading(false);
		};

		!reports && fetchReports();
		zones.length === 0 && fetchZones();

		const timer = setTimeout(() => fetchData(), 1000);

		return () => clearTimeout(timer);
	}, [reports]);

	const handleRegistered = async () => {
		try {
			await AxiosInstance({
				method: "get",
				url: `/api/v1/reports/registered`,
				headers: {
					"Content-Type": "application/pdf",
				},
			});
		} catch (err) {
			console.log(err);
		}
	};
	const handleHomestels = async () => {
		try {
			await AxiosInstance({
				method: "get",
				url: `/api/v1/reports/homestels`,
				headers: {
					"Content-Type": "application/pdf",
				},
			});
		} catch (err) {
			console.log(err);
		}
	};

	const handleHostels = async () => {
		try {
			await AxiosInstance({
				method: "get",
				url: `/api/v1/reports/hostels`,
				headers: {
					"Content-Type": "application/pdf",
				},
			});
		} catch (err) {
			console.log(err);
		}
	};
	const handleOwners = async () => {
		try {
			await AxiosInstance({
				method: "get",
				url: `/api/v1/reports/owners`,
				headers: {
					"Content-Type": "application/pdf",
				},
			});
		} catch (err) {
			console.log(err);
		}
	};
	const handleMangers = async () => {
		try {
			await AxiosInstance({
				method: "get",
				url: `/api/v1/reports/managers`,
				headers: {
					"Content-Type": "application/pdf",
				},
			});
		} catch (err) {
			console.log(err);
		}
	};
	const handlePorters = () => {
		// setInnerLoad(true);
		const minfunc = async () => {
			try {
				await AxiosInstance({
					method: "get",
					url: `/api/v1/reports/porters`,
					headers: {
						"Content-Type": "application/pdf",
					},
				});

				// setInnerLoad(false);
			} catch (err) {}
		};

		let timer = setTimeout(() => minfunc(), 2000);

		return () => clearTimeout(timer);
	};
	const handleZonalReport = (values) => {
		const minfunc = async () => {
			try {
				await AxiosInstance({
					method: "post",
					url: `/api/v1/reports/zonalreport`,
					headers: {
						"Content-Type": "application/json",
					},
					data: {
						zoneId: values.zoneId,
						type: values.type,
					},
				});

				// setInnerLoad(false);
			} catch (err) {}
		};

		let timer = setTimeout(() => minfunc(), 2000);

		return () => clearTimeout(timer);
	};
	const validationSchema = Yup.object({
		zoneId: Yup.string().required("Zone is required"),
		type: Yup.string().required("Residence Type required"),
	});

	const initialValues = {
		zoneId: zone_selected ?? "",
		type: type_selected ?? "",
	};
	return (
		<>
			<div className=" page-container mt-3 mb-3  ">
				<Toptitle page="Reports" />
				{isLoading ? (
					<CustomSpinner type="beat" />
				) : (
					<div className="card">
						<div className="card-box-flex">
							<div className="card-box-report box-8">
								<div className="card-box-inlineflex">
									<div>
										<p>HOSTELS</p>
										<h1>{data.hostels_num}</h1>
									</div>
									<div>
										<FaChartPie size={58} color="white" />
									</div>
								</div>
								<Button onClick={() => handleHostels()}>
									{" "}
									Generate Report
								</Button>
								<FaArrowRight size={30} color="#ccc" />
							</div>
							<div className="card-box-report box-1">
								<div className="card-box-inlineflex">
									<div>
										<p>HOMESTELS</p>
										<h1>{data.homestels_num}</h1>
									</div>
									<div>
										<FaChartPie size={58} color="white" />
									</div>
								</div>
								<Button onClick={() => handleHomestels()}>
									{" "}
									Generate Report
								</Button>
								<FaArrowRight size={30} color="#ccc" />
							</div>

							<div className="card-box-report box-6">
								<div className="card-box-inlineflex">
									<div>
										<p>REG RESIDENCES</p>
										<h1>{reports && reports?.residencesCount}</h1>
									</div>
									<div>
										<FaChartPie size={58} color="white" />
									</div>
								</div>
								<Button onClick={() => handleRegistered()}>
									{" "}
									Generate Report
								</Button>
								<FaArrowRight size={30} color="#ccc" />
							</div>

							<div className="card-box-report box-7">
								<div className="card-box-inlineflex">
									<div>
										<p>OWNERS </p>
										<h1>{reports && reports?.ownersCount}</h1>
									</div>
									<div>
										<FaChartPie size={58} color="white" />
									</div>
								</div>
								<Button onClick={() => handleOwners()}> Generate Report</Button>
								<FaArrowRight size={30} color="#ccc" />
							</div>
							<div className="card-box-report box-4">
								<div className="card-box-inlineflex">
									<div>
										<p>MANAGERS </p>
										<h1>{reports && reports?.managersCount}</h1>
									</div>
									<div>
										<FaChartPie size={58} color="white" />
									</div>
								</div>
								<Button onClick={() => handleMangers()}>
									{" "}
									Generate Report
								</Button>
								<FaArrowRight size={30} color="#ccc" />
							</div>
							<div className="card-box-report box-3">
								<div className="card-box-inlineflex">
									<div>
										<p>PORTERS</p>
										<h1>{reports && reports?.portersCount}</h1>
									</div>
									<div>
										<FaChartPie size={58} color="white" />
									</div>
								</div>

								<>
									<Button onClick={() => handlePorters()}>
										{" "}
										Generate Report
									</Button>
									<FaArrowRight size={30} color="#ccc" />
								</>
							</div>
						</div>
					</div>
				)}

				<div>
					<h3>Generate Reports for Zones</h3>
					<div>
						<Formik
							enableReinitialize={true}
							initialValues={initialValues}
							validationSchema={validationSchema}
							onSubmit={async (values, { resetForm }) => {
								await handleZonalReport(values);
								resetForm();
							}}
						>
							<Form>
								<div className="row">
									<div className="col-md-4 coll-sm-12">
										<Field
											as="select"
											className="form-select"
											placeholder="Location"
											name="zoneId"
										>
											<option> Select Zone</option>
											{zones.map((item, i) => (
												<option key={item._id} value={item._id}>
													{item.name}
												</option>
											))}
										</Field>

										<ErrorMessage name="zone" render={renderError} />
									</div>
									<div className="col-md-4 coll-sm-12 sm-view">
										<Field
											as="select"
											className="form-select"
											placeholder="Location"
											name="type"
										>
											<option> Select Residence Type</option>
											<option value={"Hostel"}>Hostels</option>
											<option value={"Homestel"}>Homestels</option>
											<option value={"Other"}>Others</option>
										</Field>

										<ErrorMessage name="years" render={renderError} />
									</div>
									<div className="col-md-2 col-sm-12 mb-3">
										<Button type="submit " variant="success">
											Generate Report
										</Button>
									</div>
								</div>
							</Form>
						</Formik>
					</div>
				</div>
			</div>
		</>
	);
};

export default Reports;
